import { render, staticRenderFns } from "./drone-policy-detail-info.vue?vue&type=template&id=15771227&scoped=true&"
import script from "./drone-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./drone-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./drone-policy-detail-info.vue?vue&type=style&index=0&id=15771227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15771227",
  null
  
)

export default component.exports